'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/maintenance-kinds/:maintenanceKindId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/maintenance-kinds/:maintenanceKindId/enable', method: 'PUT'},
            delete: {url: 'api/maintenance-kinds/:maintenanceKindId/delete', method: 'PUT'},
            getDefault: {url: 'api/maintenance-kinds/default', method: 'GET'},
            setDefault: {url: 'api/maintenance-kinds/:maintenanceKindId/default', method: 'PUT'},
            isUniqueName: {url: 'api/maintenance-kinds/unique/name/:name', method: 'GET'}
        });
    }];